export function findParent(
  dom: HTMLElement | null,
  condition: string | ((current: HTMLElement) => boolean)
) {
  if (!dom) return null;
  const compare =
    typeof condition === "string"
      ? (current: HTMLElement) => current.classList.contains(condition)
      : condition;

  return findParentPure(dom, compare);
}

function findParentPure(
  dom: HTMLElement | null,
  compare: (current: HTMLElement) => boolean
): HTMLElement | null {
  if (!dom) return null;
  if (compare(dom)) {
    return dom;
  }
  return findParentPure(dom.parentElement, compare);
}

export function findChild(
  dom: HTMLElement | Element | null,
  condition: string | ((current: HTMLElement | Element) => boolean)
): HTMLElement | Element | null {
  if (!dom) return null;

  const compare =
    typeof condition === "string"
      ? (current: HTMLElement | Element) =>
          current.classList.contains(condition)
      : condition;

  return findChildPure(dom, compare);
}

function findChildPure(
  dom: HTMLElement | Element | null,
  compare: (current: HTMLElement | Element) => boolean
): HTMLElement | Element | null {
  if (!dom) return null;
  if (compare(dom)) {
    return dom;
  }
  const length = Number(dom.children.length);
  for (let i = 0; i < length; i++) {
    const child = findChildPure(dom.children.item(i), compare);
    if (child) {
      return child;
    }
  }
  return null;
}

export function classNameSplice(pre: string): (className: string) => string;
export function classNameSplice(pre: string, className: string): string;
export function classNameSplice(pre: string, className?: string) {
  if (className === undefined)
    return (className: string) => pre + "-" + className;
  return pre + "-" + className;
}

export function toggleClass(
  dom: HTMLElement | null | Element,
  className: string
) {
  if (!dom) return;
  if (dom.classList.contains(className)) {
    dom.classList.remove(className);
  } else {
    dom.classList.add(className);
  }
}

export function addClass(dom: HTMLElement | null | Element, className: string) {
  if (!dom) return;
  if (dom.classList.contains(className)) return;
  dom.classList.add(className);
}

export function handleClassByCondition(
  dom: HTMLElement | null | Element,
  className: string,
  condition: boolean
) {
  if (!dom) return;
  condition ? addClass(dom, className) : dom.classList.remove(className);
}
